import { render, staticRenderFns } from "./shareInfo.vue?vue&type=template&id=35ab4eed&scoped=true"
import script from "./shareInfo.vue?vue&type=script&lang=js"
export * from "./shareInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab4eed",
  null
  
)

export default component.exports